export class DraftClasses {
}
